import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

export default function NoDataComponent({
  textAlign = 'center',
  align = 'center',
  height,
  message = 'Currently, no data present',
  className,
  style = {},
}) {
  return (
    <Container align={align} textAlign={textAlign} height={height} className={className} style={style}>
      <StyledTypography variant="body1">{message}</StyledTypography>
    </Container>
  );
}

const Container = styled.div`
  height: ${(props) => props.height || '100%'};
  display: flex;
  justify-content: center;
  align-items: ${(props) => props.align};
  text-align: ${(props) => props.textAlign};
  // padding: 1rem;
`;
